declare var swal: any;

export class QuickStartService {

    constructor() {}

    //////////////////////////////////////////////////////////////
    // VIDEOS FOR STAGE 1
    //////////////////////////////////////////////////////////////

    public async startGrundbefehleS1() {
        //Grundbefehle Stage 1
        setTimeout(function () {
            swal({
                html: '<iframe width="100%" height="300" src="https://xlogo.inf.ethz.ch/tutorials/01_Grundbefehle.mp4" frameborder="0"></iframe>',
                showCancelButton: false,
                showConfirmButton: false
            });
        }.bind(this), 100);
    }

    public async startHintergrundbilderS1() { 
        //Hintergrundbilder Stage 1
        setTimeout(function () {
            swal({
                html: '<iframe width="100%" height="300" src="https://xlogo.inf.ethz.ch/tutorials/02_Hintergrundbilder.mp4" frameborder="0"></iframe>',
                showCancelButton: false,
                showConfirmButton: false
            });
        }.bind(this), 100);
    }

    public async startAufgabensammlungS1() {
        //Grundbefehle Stage 1
        setTimeout(function () {
            swal({
                html: '<iframe width="100%" height="300" src="https://xlogo.inf.ethz.ch/tutorials/03_Aufgabensammlung.mp4" frameborder="0"></iframe>',
                showCancelButton: false,
                showConfirmButton: false
            });
        }.bind(this), 100);
    }

    public async startEigeneAufgabenS1() {
        //Grundbefehle Stage 1
        setTimeout(function () {
            swal({
                html: '<iframe width="100%" height="300" src="https://xlogo.inf.ethz.ch/tutorials/04_AufgabeErfinden.mp4" frameborder="0"></iframe>',
                showCancelButton: false,
                showConfirmButton: false
            });
        }.bind(this), 100);
    }

    //////////////////////////////////////////////////////////////
    // VIDEOS FOR STAGE 2
    //////////////////////////////////////////////////////////////

    public async startGrundbefehleS2() {
        //Grundbefehle Stage 2
        setTimeout(function () {
            swal({
                html: '<iframe width="100%" height="300" src="https://xlogo.inf.ethz.ch/tutorials/21_GrundbefehleS2.mp4" frameborder="0"></iframe>',
                showCancelButton: false,
                showConfirmButton: false
            });
        }.bind(this), 100);
    }

    //////////////////////////////////////////////////////////////
    // VIDEOS FOR STAGE 3
    //////////////////////////////////////////////////////////////

    public async startGrundbefehleS3() {
        //Grundbefehle Stage 2
        setTimeout(function () {
            swal({
                html: '<iframe width="100%" height="300" src="https://xlogo.inf.ethz.ch/tutorials/31_Grundbefehle.mp4" frameborder="0"></iframe>',
                showCancelButton: false,
                showConfirmButton: false
            });
        }.bind(this), 100);
    }

    public async startModularityS3() {
        //Grundbefehle Stage 2
        setTimeout(function () {
            swal({
                html: '<iframe width="100%" height="300" src="https://xlogo.inf.ethz.ch/tutorials/32_Modularity.mp4" frameborder="0"></iframe>',
                showCancelButton: false,
                showConfirmButton: false
            });
        }.bind(this), 100);
    }

    public async startSchrittweiseS3() {
        //Grundbefehle Stage 2
        setTimeout(function () {
            swal({
                html: '<iframe width="100%" height="300" src="https://xlogo.inf.ethz.ch/tutorials/33_SchrittweiseS3.mp4" frameborder="0"></iframe>',
                showCancelButton: false,
                showConfirmButton: false
            });
        }.bind(this), 100);
    }

}


// WEBPACK FOOTER //
// ./src/app/services/quickstart.service.ts